export class AbstractUI {


    constructor(domElement) {

        this.domElement = domElement

    }

    bindEvents (){


    }


}